import React from 'react';
import { NoteDefaultIcon } from 'shared/assets/svg/NoteDefaultIcon';
import { NoteSuggestionIcon } from 'shared/assets/svg/NoteSuggestionIcon';
import { NoteSpecificErrorIcon } from 'shared/assets/svg/NoteSpecificErrorIcon';
import { NoteGenericErrorIcon } from 'shared/assets/svg/NoteGenericErrorIcon';
import { NoteImportantIcon } from 'shared/assets/svg/NoteImportantIcon';
import { NoteAttentionIcon } from 'shared/assets/svg/NoteAttentionIcon';
import styles from './IconNote.module.scss';

export type IconNoteType =
  | 'note'
  | 'suggestion'
  | 'specific-error'
  | 'generic-error'
  | 'important'
  | 'attention';

interface IconNoteProps {
  type: IconNoteType;
  title: string;
  body: string;
  className?: string;
}

const iconMap: Record<IconNoteType, React.FC<{ className?: string }>> = {
  note: NoteDefaultIcon,
  suggestion: NoteSuggestionIcon,
  'specific-error': NoteSpecificErrorIcon,
  'generic-error': NoteGenericErrorIcon,
  important: NoteImportantIcon,
  attention: NoteAttentionIcon,
};

const colorMap: Record<IconNoteType, string> = {
  note: '#00549F',
  suggestion: '#00549F',
  'specific-error': '#BB2525',
  'generic-error': '#BB2525',
  important: '#008A00',
  attention: '#EB7100',
};

export const IconNote: React.FC<IconNoteProps> = ({ type, title, body, className }) => {
  const Icon = iconMap[type];
  const color = colorMap[type];

  return (
    <div className={`${styles.container} ${className || ''}`}>
      <div className={styles.bar} style={{ backgroundColor: color }} />
      <div className={styles.content}>
        <div className={styles.header}>
          <Icon className={styles.icon} />
          <span className={styles.title} style={{ color }}>
            {title}
          </span>
        </div>
        <div className={styles.body}>{body}</div>
      </div>
    </div>
  );
};
